import React from 'react';
import ld from 'lodash';
import FormPureComponent from '../generic.component.jsx';
import { Checkbox } from '../checkbox/checkbox.jsx';
import DropDown from '../dropdown/dropdown.jsx';
import DateOfBirth from '../date.of.birth/date.of.birth.jsx';
import style from './multibirth.less';
import _ from '../../i18n.jsx';
import { reverseRelationTypeToGenderRelation, EMPTY_STRING, EMPTY_OBJECT } from '../../questionnaire.utils.jsx';
import { getPropsOrDefault, compareObjectsInclusive } from '../../../common/utils.jsx';
import { IDENTICAL, FRATERNAL, MULTIBIRTH_PATH, YES_VALUE, TWIN_TYPE_FIELD_NAME,
    PERSON_BIRTH_GROUP_FIELD_NAME, DATE_OF_BIRTH_FIELD_NAME, GENDER_FIELD_NAME, ADOPTED_FIELD_NAME } from './reducer.jsx';

const twinTypes = [
    { name: _('Fraternal'), value: FRATERNAL },
    { name: _('Identical'), value: IDENTICAL }
];
const SINGLE_SPACE = ' ';
export class MultibirthItem extends FormPureComponent {
    constructor() {
        super();
        this.changeTwinType = this.changeTwinType.bind(this);
        this.modifyBirthGroup = this.modifyBirthGroup.bind(this);
    }

    changeTwinType(name, value) {
        this._setFieldValue(TWIN_TYPE_FIELD_NAME, [ this.props.value, value ], this.props.root);
    }
    modifyBirthGroup() {
        this._setFieldValue(PERSON_BIRTH_GROUP_FIELD_NAME, [ this.props.value, this.props.checked ], this.props.root);
    }
    render() {
        const { title, checked, value, multibirthType, root, sameGender, disabled } = this.props;
        const id = `${root.replace(/\s/g, '-')}-${PERSON_BIRTH_GROUP_FIELD_NAME}-${value}`;
        const num = parseInt(value);
        const disabledDropDown = !(checked && sameGender) || disabled;
        return (
            <span>
                <Checkbox disabled={disabled} title={title} name={PERSON_BIRTH_GROUP_FIELD_NAME} id={id} checked={checked}
                          cssClass={style.checkbox} value={value} onChangeCallback={this.modifyBirthGroup} num={num}/>
                <DropDown options={twinTypes} value={multibirthType || FRATERNAL} name={TWIN_TYPE_FIELD_NAME}
                          cssDropdownClass={style.dropdown} cssClassWrapper={style.dropdownWrapper}
                          onChangeCallback={this.changeTwinType} disabled={disabledDropDown}/>
            </span>
        );
    }
}

export default class Multibirth extends FormPureComponent {
    static canBeTwins(leftAdoptionStatus, rightAdoptionStatus) {
        return (leftAdoptionStatus && rightAdoptionStatus) || (!leftAdoptionStatus && !rightAdoptionStatus);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'root', 'withProband', 'schemaName', 'disabled' ])
                || !ld.isEqual(this.props.localValues, nextProps.localValues)
                || !ld.isEqual(this.props.fieldValues, nextProps.fieldValues);
    }
    render() {
        const { NO_SIBLINGS, PATIENT } = Multibirth.STRINGS;
        const { fieldValues, root, localValues, withProband, schemaName, disabled } = this.props;
        if (YES_VALUE !== localValues.isTwin) { return null; }

        const personId = root.match(/\d{1,3}$/)[0];
        const pathToSiblings = root.replace(/\d{1,3}$/, EMPTY_STRING).trim();
        const pathToMultibirth = root.replace(/data \d{1,3}$/, MULTIBIRTH_PATH).trim();

        const multibirths = getPropsOrDefault(fieldValues, pathToMultibirth, [], SINGLE_SPACE);
        const birthGroup = multibirths.find((_birthGroup) => -1 !== _birthGroup.persons.indexOf(personId));
        const personData = getPropsOrDefault(fieldValues, root, EMPTY_OBJECT, SINGLE_SPACE);
        const personGender = (personData[GENDER_FIELD_NAME] || EMPTY_STRING).toLowerCase();
        const personDob = (personData[DATE_OF_BIRTH_FIELD_NAME] || EMPTY_STRING).toLowerCase();
        const isPersonAdopted = YES_VALUE === (personData[ADOPTED_FIELD_NAME] || EMPTY_STRING).toLowerCase();

        const siblings = getPropsOrDefault(fieldValues, pathToSiblings, EMPTY_OBJECT, SINGLE_SPACE);

        let siblingsList = ld.map(siblings, (sibling, index) => {
            if (index === personId) { return null; }
            const isSiblingAdopted = YES_VALUE === (sibling[ADOPTED_FIELD_NAME] || EMPTY_STRING).toLowerCase();
            if (!Multibirth.canBeTwins(isPersonAdopted, isSiblingAdopted)) { return null; }
            let isChecked = false,
                multibirthType = FRATERNAL;
            if (birthGroup) {
                isChecked = -1 !== birthGroup.persons.indexOf(index);
                const isIdentical = birthGroup.identicalGroups.some((identicalGroup) => {
                    const currentSiblingIsIdentical = -1 !== identicalGroup.indexOf(index);
                    const srcPersonIsIdentical = -1 !== identicalGroup.indexOf(personId);
                    return currentSiblingIsIdentical && srcPersonIsIdentical;
                });
                multibirthType = isIdentical ? IDENTICAL : FRATERNAL;
            }
            const namePlaceholder = reverseRelationTypeToGenderRelation(schemaName, sibling.gender);
            const isSameGender = personGender === sibling.gender.toLowerCase();
            return <MultibirthItem title={sibling.name || `${namePlaceholder} ${index}`} value={index} root={root} checked={isChecked}
                                   key={`${namePlaceholder}-${index}`} disabled={disabled} multibirthType={multibirthType} sameGender={isSameGender}/>;
        });
        if (withProband && !isPersonAdopted) {
            const PROBAND_INDEX = '0';
            const probandName = fieldValues.name || PATIENT;
            const probandGender = fieldValues.gender;
            const isSameGender = probandGender ? personGender === probandGender.toLowerCase() : false;
            let isChecked = false,
                multibirthType = FRATERNAL;
            if (birthGroup) {
                isChecked = -1 !== birthGroup.persons.indexOf(PROBAND_INDEX);
                const isIdentical = birthGroup.identicalGroups.some((identicalGroup) => {
                    const currentSiblingIsIdentical = -1 !== identicalGroup.indexOf(PROBAND_INDEX);
                    const srcPersonIsIdentical = -1 !== identicalGroup.indexOf(personId);
                    return currentSiblingIsIdentical && srcPersonIsIdentical;
                });
                multibirthType = isIdentical ? IDENTICAL : FRATERNAL;
            }
            const probandItem = <MultibirthItem title={probandName} value={PROBAND_INDEX} root={root} checked={isChecked}
                                    key={probandName} multibirthType={multibirthType} disabled={disabled} sameGender={isSameGender}/>;
            siblingsList = [probandItem].concat(siblingsList);
        }
        return (
            <div className={style.wrapper}>
                <label className={style.label}>{_('Mark children in this birth')}</label>
                {
                    Object.keys(siblingsList).length
                    ? siblingsList
                    : NO_SIBLINGS
                }
                <DateOfBirth cssDropdownClass={style.dobDropdown} disabled={disabled} name="dob" root={root} value={personDob}/>
            </div>
        );
    }
}
Multibirth.STRINGS = {
    SIBLING: _('Sibling'),
    SIBLINGS: _('Siblings'),
    NO_SIBLINGS: _('No siblings'),
    PATIENT: _('Patient'),
    PROBAND: _('PROBAND')
};
